<template>
  <select v-model="selected">
    <option></option>
    <option
      v-for="semester of semesters" :key="semester.code"
      :value="semester">
        {{ semester.name }}
    </option>
  </select>
</template>

<script lang="ts">
import { Semester } from '@/store/master/types'
import { RootState } from '@/store/types'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SemesterInput extends Vue {
  @Prop() value!: Semester

  created() {
    this.$store.dispatch('fetchMasterSemesters')
  }

  private get semesters(): Semester[] {
    return (this.$store.state as RootState).master.semesters
  }

  private get selected(): Semester {
    return this.value
  }

  private set selected(semester: Semester) {
    this.$emit('input', semester)
  }
}
</script>

<style scoped>
  select{
    padding: 5px;
    border: 1px solid #AAAFB6;
    border-radius: 30px;
    width: 100%;
  }
</style>
